import type { EvidenceAwarenessPopupVariant } from '@/features/flags/legacy-flags';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const createSsrSafeStorage = <T>() =>
  createJSONStorage<T>(() => {
    if (typeof window === 'undefined') {
      return {
        getItem: () => null,
        setItem: () => undefined,
        removeItem: () => undefined,
      };
    }
    return window.localStorage;
  });

/**
 * Non-production dev-tools override for PostHog multivariate `exp-evidence-awareness-popup`.
 * `null` means use PostHog / boot evaluation. Ignored in production (see `flags.ts`).
 */
export const sessionlessEvidenceAwarenessDevVariantOverrideAtom =
  atomWithStorage<EvidenceAwarenessPopupVariant | null>(
    'heidi.devTools.sessionlessEvidenceAwareness.variantOverride',
    null,
    createSsrSafeStorage<EvidenceAwarenessPopupVariant | null>(),
    { getOnInit: true }
  );

sessionlessEvidenceAwarenessDevVariantOverrideAtom.debugLabel =
  'sessionlessEvidenceAwarenessDevVariantOverrideAtom';

/**
 * When true (non-production), fetch personalized suggestions even if normal eligibility is false
 * so the awareness card can be previewed. Ignored in production.
 */
export const sessionlessEvidenceAwarenessDevForceShowAtom = atomWithStorage<boolean>(
  'heidi.devTools.sessionlessEvidenceAwareness.forceShow',
  false,
  createSsrSafeStorage<boolean>(),
  { getOnInit: true }
);

sessionlessEvidenceAwarenessDevForceShowAtom.debugLabel =
  'sessionlessEvidenceAwarenessDevForceShowAtom';
